/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import MoserObject from './MoserObject';
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper

/**
 * <p>Java class for tableItemType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="tableItemType"&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;choice&gt; &lt;element ref="{}column"/&gt; &lt;element ref="{}struct"/&gt; &lt;element ref="{}multiset"/&gt; &lt;/choice&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class TableItemType extends MoserObject{

	column = null;

	struct = null;

	multiset = null;



	/**
	 * Gets the value of the column property.
	 * @return {Column} possible object is {@link Column}
	 */
	getColumn() {
		return this.column;
	}

	/**
	 * Sets the value of the column property.
	 * @param {Column} value allowed object is {@link Column}
	 */
	setColumn(value) {
		var oldValue = this.column;
		this.column = value;
		this._setAndNotify(196, oldValue, value, true, false);
	}

	/**
	 * Gets the value of the struct property.
	 * @return {Struct} possible object is {@link Struct}
	 */
	getStruct() {
		return this.struct;
	}

	/**
	 * Sets the value of the struct property.
	 * @param {Struct} value allowed object is {@link Struct}
	 */
	setStruct(value) {
		var oldValue = this.struct;
		this.struct = value;
		this._setAndNotify(200, oldValue, value, true, false);
	}

	/**
	 * Gets the value of the multiset property.
	 * @return {Multiset} possible object is {@link Multiset}
	 */
	getMultiset() {
		return this.multiset;
	}

	/**
	 * Sets the value of the multiset property.
	 * @param {Multiset} value allowed object is {@link Multiset}
	 */
	setMultiset(value) {
		var oldValue = this.multiset;
		this.multiset = value;
		this._setAndNotify(201, oldValue, value, true, false);
	}

	/**
	 * Creates a new instance of <code>TableItemType</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> TableItemType</code> object from.
	 * @return {TableItemType} an object of type <code>TableItemType</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createTableItemType();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "TableItemType";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		var clazz;
		if (factory) {
			clazz = factory.createColumn().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 196, "column", clazz));
		if (factory) {
			clazz = factory.createStruct().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 200, "struct", clazz));
		if (factory) {
			clazz = factory.createMultiset().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 201, "multiset", clazz));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 196:
			this.setColumn((value));
			break;
		case 200:
			this.setStruct((value));
			break;
		case 201:
			this.setMultiset((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 196:
			return this.getColumn();
		case 200:
			return this.getStruct();
		case 201:
			return this.getMultiset();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 196:
			return this.getColumn();
		case 200:
			return this.getStruct();
		case 201:
			return this.getMultiset();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/TableItemType.js